import AccountStatusAlertBanners from '@components/dataCollections/collections/AccountStatusAlertBanners.tsx';
import AppBar from '@mui/material/AppBar';
import Stack from '@mui/material/Stack';
import {Outlet} from 'react-router';

const DataCollectionsLayout = () => (
  <Stack
    sx={{
      blockSize: '100%',
      inlineSize: '100%',
      overflow: 'auto',
    }}
  >
    <AppBar position="sticky" elevation={0}>
      <AccountStatusAlertBanners sx={{marginBlockStart: 4, marginInline: 5}} />
    </AppBar>
    <Outlet />
  </Stack>
);

export default DataCollectionsLayout;
